import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import { __decorate } from "tslib";
import { Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
var ColorPicker = /*#__PURE__*/function (_Vue) {
  function ColorPicker() {
    var _this;
    _classCallCheck(this, ColorPicker);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ColorPicker, [].concat(args));
    _defineProperty(_this, "width", void 0);
    _defineProperty(_this, "height", void 0);
    _defineProperty(_this, "panelChoose", void 0);
    // value => {return (/^#[0-9a-f]{3,6}$/i).test(value);
    _defineProperty(_this, "defaultColor", void 0);
    _defineProperty(_this, "color", void 0);
    _defineProperty(_this, "canvas", void 0);
    _defineProperty(_this, "selectedColor", void 0);
    return _this;
  }
  _inherits(ColorPicker, _Vue);
  return _createClass(ColorPicker, [{
    key: "mounted",
    value: function mounted() {
      this.color = this.defaultColor;
      this.selectedColor = this.color;
      this.canvas = document.getElementById('canvas');
    }
  }, {
    key: "onClick",
    value: function onClick() {
      this.selectAColor(this.color);
    }
  }, {
    key: "selectAColor",
    value: function selectAColor(color) {
      this.color = color;
      this.selectedColor = color;
      this.$emit('onSelection', this.color);
    }
  }, {
    key: "onMouseMove",
    value: function onMouseMove(evt) {
      var hexColor = this.getHexColor(evt);
      this.color = hexColor;
    }
  }, {
    key: "onMouseOut",
    value: function onMouseOut(evt) {
      this.color = this.selectedColor;
    }
  }, {
    key: "getHexColor",
    value: function getHexColor(evt) {
      var canvasX = evt.pageX - this.canvas.offsetLeft;
      var canvasY = evt.pageY - this.canvas.offsetTop;
      var yPosition = (this.canvas.height - canvasY) / this.canvas.height * 100;
      var percent = Math.round((this.canvas.width - canvasX) / this.canvas.width * 100);
      var h = 3.6 * percent;
      var s = Math.round(yPosition / 3 + 50);
      var l = Math.round(yPosition / 3 + 40);
      var hex = this.hslToHex(h, s, l);
      return hex;
    }
  }, {
    key: "hslToHex",
    value: function hslToHex(h, s, l) {
      h /= 360;
      s /= 100;
      l /= 100;
      var r;
      var g;
      var b;
      if (s === 0) {
        r = g = b = l;
      } else {
        var hueToRgb = function hueToRgb(p, q, t) {
          if (t < 0) {
            t += 1;
          }
          if (t > 1) {
            t -= 1;
          }
          if (t < 1 / 6) {
            return p + (q - p) * 6 * t;
          }
          if (t < 1 / 2) {
            return q;
          }
          if (t < 2 / 3) {
            return p + (q - p) * (2 / 3 - t) * 6;
          }
          return p;
        };
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = hueToRgb(p, q, h + 1 / 3);
        g = hueToRgb(p, q, h);
        b = hueToRgb(p, q, h - 1 / 3);
      }
      var toHex = function toHex(x) {
        var hex = Math.round(x * 255).toString(16);
        return hex.length === 1 ? '0' + hex : hex;
      };
      return "#".concat(toHex(r)).concat(toHex(g)).concat(toHex(b)).toUpperCase();
    }
  }]);
}(Vue);
export { ColorPicker as default };
__decorate([Prop({
  default: 800
})], ColorPicker.prototype, "width", void 0);
__decorate([Prop({
  default: 100
})], ColorPicker.prototype, "height", void 0);
__decorate([Prop({
  default: true
})], ColorPicker.prototype, "panelChoose", void 0);
__decorate([Prop({
  default: '#F8550F'
})], ColorPicker.prototype, "defaultColor", void 0);
__decorate([Prop({
  default: '#F8550F'
})], ColorPicker.prototype, "color", void 0);